import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { ShoppingBag, Search, Menu, X, User } from "lucide-react";
import { useCart } from "../lib/store";
import { CatalogMenu } from "./CatalogMenu";

export const Logo = ({ size = "md" }) => {
  const big = size === "lg";
  return (
    <Link to="/" data-testid="brand-logo" aria-label="VLOVER by Next Level" className="flex items-center gap-3 shrink-0">
      <img src="/nl-monogram.png" alt="" className={big ? "h-14" : "h-9 sm:h-10"} />
      <span className="flex flex-col items-center leading-none">
        <span className={`copper-text font-semibold tracking-[0.32em] pl-[0.32em] ${big ? "text-4xl" : "text-[1.35rem] sm:text-[1.55rem]"}`} style={{ fontFamily: "Manrope, sans-serif" }}>VLOVER</span>
        <span className="flex items-center gap-2 mt-1.5 w-full">
          <span className="copper-rule h-px flex-1" />
          <span className="copper-text text-[0.5rem] sm:text-[0.56rem] tracking-[0.34em] pl-[0.34em] font-medium uppercase">by Next Level</span>
          <span className="copper-rule h-px flex-1" />
        </span>
      </span>
    </Link>
  );
};

const nav = [["/pvc", "PVC-vloeren"], ["/laminaat", "Laminaat"], ["/ondervloeren", "Ondervloeren"], ["/plinten", "Plinten"], ["/profielen", "Profielen"], ["/merken", "Merken"], ["/info/verzending", "Levering"]];

export default function Header() {
  const { count } = useCart();
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const nav_ = useNavigate();
  const submit = (e) => { e.preventDefault(); if (q.trim()) { nav_(`/zoeken?q=${encodeURIComponent(q.trim())}`); setOpen(false); } };
  return (
    <header className="sticky top-0 z-40 bg-[#272D30] text-[#F5F1EA] border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-[72px] flex items-center gap-6">
        <button className="lg:hidden p-2 -ml-2" onClick={() => setOpen(!open)} aria-label="Menu" aria-expanded={open} data-testid="mobile-menu-toggle">{open ? <X size={22} /> : <Menu size={22} />}</button>
        <Logo />
        <nav className="hidden lg:flex items-center gap-4 xl:gap-5 ml-3">

          {nav.filter(([to]) => !["/ondervloeren", "/plinten", "/profielen"].includes(to)).map(([to, l]) => (
            <NavLink key={to} to={to} data-testid={`nav-${to.replace(/\//g, "")}`} className={({ isActive }) => `text-sm font-medium whitespace-nowrap transition-colors ${isActive ? "text-[#D9A48C]" : "text-[#F5F1EA]/90 hover:text-[#D9A48C]"}`}>{l}</NavLink>
          ))}
        </nav>
        <form onSubmit={submit} className="hidden md:flex ml-auto items-center bg-white/5 border border-white/15 rounded px-3 h-10 w-72 focus-within:border-[#B78B7B] transition-colors">
          <Search size={16} className="text-white/60" />
          <input data-testid="header-search-input" aria-label="Zoeken naar producten, categorieën of artikelnummers" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Zoek op naam, merk, artikelnr. of EAN" className="bg-transparent outline-none text-sm ml-2 w-full placeholder:text-white/45" />
        </form>
        <Link to="/account" className="ml-auto md:ml-2 p-2 hover:text-[#D9A48C]" aria-label="Account" data-testid="header-account-link"><User size={20} /></Link>
        <Link to="/winkelwagen" className="relative p-2 hover:text-[#D9A48C]" aria-label="Winkelwagen" data-testid="header-cart-link">
          <ShoppingBag size={21} />
          {count > 0 && <span data-testid="header-cart-count" className="absolute -top-0.5 -right-0.5 bg-[#B78B7B] text-white text-[10px] min-w-[18px] h-[18px] rounded-full flex items-center justify-center">{count}</span>}
        </Link>
      </div>
      <CatalogMenu open={open} setOpen={setOpen} q={q} setQ={setQ} submit={submit} />
    </header>
  );
}
